export const centsToMinutes = (minutesInCents: number) => minutesInCents / 100

export const minutesToCents = (minutes: number) => minutes * 100
